import AnalyticsDashboardAppConfig from './analytics/AnalyticsDashboardAppConfig';

const dashboardsConfigs = [AnalyticsDashboardAppConfig];

export default dashboardsConfigs;